import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../modules/home";
import RegistrationForm from "../modules/form";
import RegConfirmation from "../modules/form/confirmation";
import InitiateRegistration from "../modules/form/initiate";
import { RegistrationRoute } from "./route";
import { useRegDetail } from "../../../shared/context/regDetail";
import RegistrationState from "../../../shared/enums/RegistrationState";
import HandleRedirects from "../../../shared/components/handleRedirects";
import CouponCodeForm from "../modules/couponCode";
import { useCopies } from "shared/hooks/useCopies";
import { getQueryParams } from "shared/hooks/useQueryParams/useQueryParams";
import QueryParamKey from "../../../shared/enums/QueryParamKey";
import PageNotFound from "shared/components/pageNotFound";
import ConsentBannerContainer from "../../../shared/consentManagement";
import { ConsentProvider } from "../../../context/consent";
import RegistrationElapsed from "shared/components/registrationElapsed";
import { CookiePage } from "shared/cookies/CookiePage";
import { InvoicePayerRegConfirmation, InvoicePayerRegPayment } from "../modules/form/invoicePayer";

/**
 * @name RegistrationRoute
 * @description Routes related to registration portal
 */
export default function RegistrationRouter() {
  const regDetailObj = useRegDetail();
  const params = getQueryParams();
  if (regDetailObj.registrationState !== RegistrationState.ON_GOING && !params[QueryParamKey.PREVIEW_MODE]) {
    return <RegistrationNotOngoing />;
  }

  return (
    <Router>
      <ConsentProvider>
        <ConsentBannerContainer />
        <Routes>
          <Route path={RegistrationRoute.Redirect} element={<HandleRedirects />} />
          <Route path={RegistrationRoute.Home} element={<Home />} />
          <Route path={RegistrationRoute.CouponCode} element={<CouponCodeForm />} />
          <Route path={RegistrationRoute.Form} element={<RegistrationForm />}>
            <Route path={RegistrationRoute.InitiateReg} element={<InitiateRegistration />} />
            <Route path={RegistrationRoute.Confirmation} element={<RegConfirmation />} />
            <Route path={RegistrationRoute.Payment} element={<InvoicePayerRegPayment />} />
            <Route path={RegistrationRoute.InvoicePayerConfirmation} element={<InvoicePayerRegConfirmation />} />
          </Route>
          <Route path={RegistrationRoute.Cookies} element={<CookiePage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ConsentProvider>
    </Router>
  );
}

function RegistrationNotOngoing() {
  const regDetailObj = useRegDetail();
  const copies = useCopies();
  const messageToDisplay = React.useMemo(() => {
    switch (regDetailObj.registrationState) {
      case RegistrationState.CONFIGURATION:
        return copies.get("registration.not.started");
      case RegistrationState.PAUSED:
        return copies.get("registration.paused");
    }
  }, [copies, regDetailObj.registrationState]);

  if (regDetailObj.registrationState === RegistrationState.ELAPSED) {
    return <RegistrationElapsed />;
  }

  return (
    <div className="regStatus">
      <p>{messageToDisplay}</p>
    </div>
  );
}
